/**
 * Hardcoded schedule items for the wedding timeline.
 * Edit the values here to change the schedule on the site.
 */
export const scheduleItems = [
  {
    "id": "ceremony",
    "order": 1,
    "description": {
      "bg": "",
      "en": "",
      "de": ""
    },
    "title": {
      "de": "Zeremonie in ",
      "bg": "Церемония в ",
      "en": "Ceremony in "
    },
    "locationLink": {
      "bg": "Параклис Agios Vasilios",
      "en": "Agios Vasilios Chapel",
      "de": "Kapelle Agios Vasilios"
    },
    "locationMapUrl": "https://maps.app.goo.gl/MttSjCtiYqqL1Hy56?g_st=ac",
    "locationDetails": {
      "bg": "Живописният каменен параклис Свети Василиос (Agios Vasilios) се намира на крайбрежния път към село Пердика, на около 3 км южно от главното пристанище на Егина.\n---\nТой е традиционна каменна постройка с просторен двор, засенчен от пищна палма, разположен точно на брега на морето. Известен е с красивите си залези и е изключително популярно място за сватби.\n---\nНамира се на около 5-7 минути с кола от пристанището на Егина.",
      "en": "The picturesque stone chapel of Agios Vasilios is located on the coastal road towards the village of Perdika, about 3 km south of the main port of Aegina.\n---\nIt is a traditional stone structure featuring a spacious courtyard shaded by a lush palm tree, situated right by the sea. It is highly popular for weddings and offers stunning sunset views.\n---\nLocated approximately 5-7 minutes drive from the main port of Aegina.",
      "de": "Die malerische Steinkapelle Agios Vasilios liegt an der Küstenstraße in Richtung des Dorfes Perdika, etwa 3 km südlich des Haupthafens von Ägina.\n---\nEs handelt sich um einen traditionellen Steinbau mit einem großen, von einer üppigen Palme beschatteten Innenhof direkt am Meer. Die Kapelle ist sehr beliebt für Hochzeiten und bietet einen wunderschönen Blick auf den Sonnenuntergang.\n---\nEtwa 5-7 Autominuten vom Haupthafen von Ägina entfernt."
    },
    "time": "12:00"
  },
  {
    "id": "free_time",
    "title": {
      "bg": "Свободна програма",
      "en": "Free and easy",
      "de": "Freie Zeit"
    },
    "order": 2,
    "description": {
      "de": "",
      "en": "",
      "bg": ""
    },
    "time": "13:00 - 19:30"
  },
  {
    "id": "dinner",
    "order": 3,
    "description": {
      "de": "",
      "bg": "",
      "en": ""
    },
    "title": {
      "en": "Dinner at",
      "bg": "Вечеря в",
      "de": "Abendessen in"
    },
    "locationLink": {
      "bg": "Таверна Axivadaki",
      "en": "Axivadaki tavern",
      "de": "Axivadaki Taverne"
    },
    "locationMapUrl": "https://www.google.com/maps/search/Achivadaki+Aegina",
    "locationDetails": {
      "bg": "\"Axivadaki\" е скрито съкровище, разположено на крайбрежния път между Фарос и Маратон, в спокойното пристанище Врохия. Това е идеалното място за релаксиращо хапване на самия бряг.\n---\nИзвестна с пресната си местна риба, домашната салата \"Axivadaki\" и лингвини със скариди, таверната предлага истинския вкус на Егейско море в спокойна, традиционна обстановка.\n---\nНамира се на около 7 минути с кола от главното пристанище на Егина.",
      "en": "Axivadaki is a hidden gem located on the coastal road between Faros and Marathon, right at the quiet port of Vrochia. It is the perfect spot for a relaxed meal directly by the water.\n---\nKnown for its fresh local fish, signature \"Axivadaki\" salad, and shrimp linguini, it offers an authentic taste of the Aegean in a peaceful, traditional setting.\n---\nLocated approximately 7 minutes drive from the main port of Aegina.",
      "de": "Axivadaki ist ein Geheimtipp an der Küstenstraße zwischen Faros und Marathon, am ruhigen Hafen von Vrochia. Es ist der perfekte Ort für eine entspannte Mahlzeit direkt am Wasser.\n---\nBekannt für frischen lokalen Fisch, den \"Axivadaki\"-Salat des Hauses und Garnelen-Linguine, bietet sie einen echten Geschmack der Ägis in einer friedlichen, traditionellen Umgebung.\n---\nEtwa 7 Autominuten vom Haupthafen von Ägina entfernt."
    },
    "time": "19:30"
  },
  {
    "id": "cake",
    "title": {
      "bg": "Закуска и кафе (за тези които искат)",
      "en": "Breakfast and coffee (for those who want)",
      "de": "Frühstück und Kaffee (für die, die wollen)"
    },
    "description": {
      "bg": "",
      "en": "",
      "de": ""
    },
    "order": 4,
    "time": {
      "de": "Am nächsten Morgen",
      "en": "The next morning",
      "bg": "Следващата сутрин"
    }
  }
];
